﻿import * as React from "react";
import { IActiveSectionProps } from "../../SmartToolsRoot";
import { IBaseSectionProps } from "./IBaseSectionProps";
import { IBaseSubSectionProps } from "../SubSections";
import { IToolProps } from "../Tool";
import { SectionTower } from "../SectionTower";

export interface IMenuSectionProps extends IBaseSectionProps {
    bindToolToFrame: (
        moduleID: number,
        displayName: string,
        toolLookup: string,
        toolUrl: string,
    ) => void;
    functionCall: string;
    subSections: IBaseSubSectionProps[];
}

export const MenuSection: React.FunctionComponent<IMenuSectionProps> = (
    props,
): React.ReactElement => {
    const bindOnClick = (): void => {
        let toolNode: React.ReactNode;

        const toolList: IToolProps[] = [];

        // Count the number of tools within the section
        for (let i = 0; i < props.subSections.length; i++) {
            for (let u = 0; u < props.subSections[i].tools.length; u++) {
                toolList.push(props.subSections[i].tools[u]);
            }
        }

        const smartBoardsIndex: number = props.subSections.findIndex(
            (ss) => ss.type === `SmartBoardManager`,
        );

        if (toolList.length > 1 || smartBoardsIndex !== -1) {
            toolNode = <SectionTower key={props.moduleID} {...props} />;
        } else {
            toolNode = null;
        }

        const activeProps: IActiveSectionProps = {
            moduleID: props.moduleID,
            sectionType: props.sectionType,
            tower: {
                bindComponent: toolNode,
            },
        };

        if (smartBoardsIndex !== -1) {
            props.toggleSection(activeProps, activeSectionsComparer);

            const tool: IToolProps =
                props.subSections[smartBoardsIndex].tools[0];

            props.openSection(
                toolList,
                tool.moduleID,
                tool.name,
                tool.lookupName,
                tool.url,
            );
        } else {
            const tool: IToolProps = props.subSections[0].tools[0];

            if (toolList.length !== 1) {
                props.openSection(
                    toolList,
                    tool.moduleID,
                    tool.name,
                    tool.lookupName,
                    tool.url,
                );
            }

            // Toggle the section
            props.toggleSection(activeProps, activeSectionsComparer);

            // If only one then load the tool.
            if (toolList.length === 1) {
                props.bindToolToFrame(
                    tool.moduleID,
                    tool.name,
                    tool.lookupName,
                    tool.url,
                );
            }
        }
    };

    // This function is passed to the toggleSection function, and is used check if the other active sections should be active or not.
    const activeSectionsComparer = (
        activeSections: IBaseSectionProps[],
    ): IBaseSectionProps[] => {
        for (let i = 0; i < activeSections.length; i++) {
            const sectionType = activeSections[i].sectionType;

            if (
                sectionType === `MyProfile` ||
                sectionType === `ToolMenu` ||
                sectionType === `Notifications` ||
                sectionType === `ReleaseNotes` ||
                sectionType === `DataFeedStatus` ||
                sectionType === `EditProfile`
            ) {
                activeSections.splice(i, 1);
                i--;
            }
        }
        return activeSections;
    };

    const isActiveCSS: string = props.isActive ? `selected` : ``;

    return (
        <div className={`tab-section ${isActiveCSS}`} onClick={bindOnClick}>
            <img
                alt={props.name}
                src={`/Images/Icon?icon=${props.moduleID}&folder=Module`}
            />
        </div>
    );
};
